import _ from 'lodash';
import { combineReducers } from 'redux';
import types from 'frontend/state/actionTypes';

// only clear on name, consistent with clearing the simc addon text.
// being more aggressive can lead to an issue where simcItems is cleared on otherwise non-destructive operations.
// specifically, OCD user that clears armory realm but has no name in the field could clear simcItems
// while still being able to submit the sim
const clearFields = [
  'armoryName',
];

const dataReducer = (state = {}, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.FETCH_SIMC_ITEMS_SUCCESS:
      return payload.items;
    case types.INPUT_FORM:
      if (_.includes(clearFields, payload.field)) {
        return {};
      }
      return state;
    case types.FETCH_SIMC_ITEMS_REQUEST:
    case types.FETCH_CHAR_REQUEST:
    case types.FETCH_CHAR_SUCCESS:
      return {};
    default:
      return state;
  }
};

const bagsReducer = (state = [], action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.FETCH_SIMC_ITEMS_SUCCESS:
      return payload.bags;
    case types.INPUT_FORM:
      if (_.includes(clearFields, payload.field)) {
        return [];
      }
      return state;
    case types.FETCH_SIMC_ITEMS_REQUEST:
    case types.FETCH_CHAR_REQUEST:
    case types.FETCH_CHAR_SUCCESS:
      return [];
    default:
      return state;
  }
};

const loadingReducer = (state = false, action = {}) => {
  const { type } = action;
  switch (type) {
    case types.FETCH_SIMC_ITEMS_REQUEST:
      return true;
    case types.FETCH_SIMC_ITEMS_SUCCESS:
    case types.FETCH_SIMC_ITEMS_FAILURE:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  data: dataReducer,
  bags: bagsReducer,
  loading: loadingReducer,
});

export const selectors = {
  items: state => state.simbot.simcItems.data,
  bags: state => state.simbot.simcItems.bags,
  loading: state => state.simbot.simcItems.loading,
};
